import { useSearchParams } from "react-router-dom";

import { getVariants } from "./registry";

/**
 * Hook de variante activa de una vista. Fuente de verdad = query param
 * `v_<viewKey>` (compartible por URL). Si no hay param valido, usa la primera
 * variante como defecto.
 *
 * @param {string} viewKey - clave de la vista (p.ej. "overview")
 * @returns {{ variantId, variant, variants, setVariant }}
 */
export function useVariant(viewKey) {
    const [params, setParams] = useSearchParams();
    const variants = getVariants(viewKey);
    const paramKey = `v_${viewKey}`;
    const defaultId = variants[0]?.id;

    const requested = params.get(paramKey);
    const variantId = variants.some((v) => v.id === requested) ? requested : defaultId;
    const variant = variants.find((v) => v.id === variantId) || null;

    const setVariant = (id) => {
        const next = new URLSearchParams(params);
        if (!id || id === defaultId) {
            next.delete(paramKey); // el defecto no ensucia la URL
        } else {
            next.set(paramKey, id);
        }
        setParams(next, { replace: true });
    };

    return { variantId, variant, variants, setVariant };
}

export default useVariant;
